import React, { useState } from 'react';
import { Modal, Input, Form, Button, message } from 'antd';
import { changePassword } from './services';
import { IDataChangePassword } from './data';

const ModalChangePassword = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();

  const handleOk = async (values: IDataChangePassword) => {
    try {
      setLoading(true);
      await changePassword(values);
      setLoading(false);
      message.success('Đổi mật khẩu thành công!');
      form.resetFields();
      onClose();
    } catch (error: any) {
      setLoading(false);
      message.error('Đổi mật khẩu thất bại!' + error);
    }
  };

  return (
    <Modal
      title="Đổi mật khẩu"
      open={open}
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            form.resetFields();
            onClose();
          }}
        >
          Hủy
        </Button>,
        <Button key="ok" type="primary" loading={loading} onClick={() => form.submit()}>
          Xác nhận
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical" onFinish={handleOk}>
        <Form.Item
          label="Mật khẩu cũ"
          name="old_password"
          rules={[{ required: true, message: 'Vui lòng nhập mật khẩu cũ' }]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          label="Mật khẩu mới"
          name="new_password"
          rules={[{ required: true, message: 'Vui lòng nhập mật khẩu mới' }]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          label="Xác nhận mật khẩu mới"
          name="confirmPassword"
          dependencies={['newPassword']}
          rules={[
            { required: true, message: 'Vui lòng xác nhận mật khẩu mới' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('Mật khẩu xác nhận không khớp!'));
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalChangePassword;
